import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=1e58e8e4&scoped=true&"
import script from "./app-footer.vue?vue&type=script&lang=ts&"
export * from "./app-footer.vue?vue&type=script&lang=ts&"
import style0 from "./app-footer.vue?vue&type=style&index=0&id=1e58e8e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e58e8e4",
  null
  
)

export default component.exports